<div>
  <p-table [value]="producoesParametros" [paginator]="true" [rows]="20" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
    [rowsPerPageOptions]="[20, 50, 100]" [loading]="loadingParametros"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
    [scrollable]="true" scrollHeight="40.5rem" [resizableColumns]="true">
    <ng-template pTemplate="caption">
      <div class="flex align-items-center">
        <span class="text-900 font-semibold">{{ totalRecordsParametros }} Registros</span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="empresa" style="min-width: 100px;">Empresa <p-sortIcon field="empresa"></p-sortIcon></th>
        <th pSortableColumn="filial" style="min-width: 90px;">Filial <p-sortIcon field="filial"></p-sortIcon></th>
        <th pSortableColumn="tipoCalculoSemanal" style="min-width: 150px;">Tipo Cálc. Semanal <p-sortIcon field="tipoCalculoSemanal"></p-sortIcon></th>
        <th pSortableColumn="dataInicioSafra" style="min-width: 130px;">Início Safra <p-sortIcon field="dataInicioSafra"></p-sortIcon></th>
        <th pSortableColumn="dtLimite" style="min-width: 130px;">Dt. Limite Vigente <p-sortIcon field="dtLimite"></p-sortIcon></th>
        <th pSortableColumn="dtRecebido" style="min-width: 150px;">Dt. Recebido <p-sortIcon field="dtRecebido"></p-sortIcon></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td><span class="font-semibold text-900">{{ item.empresa }}</span></td>
        <td>{{ item.filial }}</td>
        <td>
          <p-tag [value]="item.tipoCalculoSemanal" severity="info" [rounded]="true" styleClass="text-xs"></p-tag>
        </td>
        <td>{{ item.dataInicioSafra }}</td>
        <td>{{ item.dtLimite }}</td>
        <td>{{ item.dtRecebido | date:'dd/MM/yyyy HH:mm:ss' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6">
          <div class="flex flex-column align-items-center justify-content-center py-5">
            <i class="pi pi-inbox text-4xl text-300 mb-3"></i>
            <span class="text-500 font-medium">Nenhum parâmetro encontrado.</span>
            <span class="text-400 text-sm mt-1">Selecione uma instância para carregar os parâmetros.</span>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
